import { GspCommonDataType, GSPElementDataType } from "@gsp-bef/gsp-cm-metadata";
import { GSPCommonObject, IGSPCommonObject } from "@gsp-bef/gsp-cm-metadata";
import { EntityType, Property, NavigationProperty, NavigationType } from "../common/Schema";
import { NewDataType, NewEntityType, NewNavigationProperty, NewNavigationType, NewProperty } from "../common/NewSchema";
/**
 * 适配器类(目前支持CDT、CO)
 * 功能：将CDT、CO转化为内部Schema中的EntityType
 */
export class Adapter {

  /**
   * 将CDT转化为entityType方法
   * @param gspCDT 待转化的CDT
   */
  public convertCDT(gspCDT: GspCommonDataType): EntityType {
    let entityType: EntityType = {
      id: gspCDT.Code,
      name: gspCDT.Code,
      key: null,
      description: gspCDT.Name,
      properties: [],
      navigationProperties: []
    }
    gspCDT.ContainElements.forEach(element => {
      let property: Property = {
        name: element.Code,
        type: element.MDataType,
        description: element.Name,
      };
      entityType.properties.push(property);
    });
    return entityType;
  }
  /**
   * 将CO转化为entityType方法
   * @param gspCO 待转化的CO
   */
  public convertCO(gspCO: GSPCommonObject): EntityType[] {
    let entityTypes: EntityType[] = [];
    entityTypes.push(this.adaptCO(gspCO, entityTypes));
    return entityTypes;
  }
  /**
   * CO转化递归方法
   * @param gspCO 待转化gspCO
   * @param entityTypes 从gspCO提取的所有主从表
   */
  private adaptCO(gspCO: IGSPCommonObject, entityTypes: EntityType[]): EntityType {
    let entityType: EntityType = {
      name: gspCO.Code,
      key: null,
      id: gspCO.Code,
      description: gspCO.Name,
      properties: [],
      navigationProperties: []
    };
    //每个属性转化
    if (gspCO.ContainElements.length != 0) {
      gspCO.ContainElements.forEach(element => {
        let property: Property = {
          name: element.Code,
          type: element.MDataType,
          description: element.Name
        };
        entityType.properties.push(property);
      });
    };
    //子表转化为导航属性
    if (gspCO.ContainChildObjects.length != 0) {
      gspCO.ContainChildObjects.forEach(childObject => {
        let naviproperty: NavigationProperty = {
          name: childObject.Code + "s",
          type: NavigationType.EntitySet,
          navigationId: childObject.Code + "s",
          description: childObject.Name
        };
        entityType.navigationProperties.push(naviproperty);
        entityTypes.push(this.adaptCO(childObject, entityTypes));
      });
    };
    return entityType;
  }

  //======================将CO转换为NewEntityType===============================================

  /**
   * @description 将CDT转换为NewEntityType
   * @param gspCDT 待转换CDT
   * @returns NewEntityType
   */
  public convertCDTOfNewSchema(gspCDT: GspCommonDataType): NewEntityType {
    let entityType: NewEntityType = {
      code: gspCDT.Code,
      name: gspCDT.Name,
      master: false,
      properties: [],
      keys: [],
      navigationProperties: []
    }
    gspCDT.ContainElements.forEach(element => {
      let property: NewProperty = {
        code: element.Code,
        name: element.Name,
        dataType: this.convertMDataType(element.MDataType),
        nullable: false,
        defaultValue: null
      }
      entityType.properties.push(property);
    });
    return entityType;
  }

  /**
  * @description 将CO转化为newEntityType方法
  * @param gspCO 待转化的CO
  * @returns NewEntityType[] NewEntityType[]
  */
  public convertCOOfNewSchema(gspCO: GSPCommonObject): NewEntityType[] {
    let entityTypes: NewEntityType[] = [];
    entityTypes.push(this.adaptCOOfNewSchema(gspCO, entityTypes));
    return entityTypes;
  }
  /**
  * CO转化递归方法
  * @param gspCO 待转化gspCO
  * @param entityTypes 从gspCO提取的所有主从表
  */
  private adaptCOOfNewSchema(gspCO: IGSPCommonObject, entityTypes: NewEntityType[]): NewEntityType {
    let entityType: NewEntityType = {
      code: gspCO.Code,
      name: gspCO.Name,
      master: false,
      properties: [],
      keys: [],
      navigationProperties: []
    };
    //每个属性转化
    if (gspCO.ContainElements.length != 0) {
      gspCO.ContainElements.forEach(element => {
        let property: NewProperty = {
          code: element.Code,
          name: element.Name,
          dataType: this.convertMDataType(element.MDataType),
          nullable: false,
          defaultValue: null
        }
        entityType.properties.push(property);
      });
    };
    //子表转化为导航属性
    if (gspCO.ContainChildObjects.length != 0) {
      gspCO.ContainChildObjects.forEach(childObject => {
        let naviproperty: NewNavigationProperty = {
          code: childObject.Code + "s",
          name: childObject.Name,
          navigationName: childObject.Code,
          navigationType: NewNavigationType.EntitySet,
          relationShip: ""
        }
        entityType.navigationProperties.push(naviproperty);
        entityTypes.push(this.adaptCOOfNewSchema(childObject, entityTypes));
      });
    };
    return entityType;
  }

  /**
   * @description （字段类型转换）BE类型转换为Schema类型
   * @param type BE类型
   * @returns NewDataType
   */
  private convertMDataType(type: GSPElementDataType): NewDataType {
    switch (type) {
      case GSPElementDataType.String:
        return NewDataType.String;
      case GSPElementDataType.Integer:
        return NewDataType.Integer;
      case GSPElementDataType.Binary:
        return NewDataType.Byte;
      case GSPElementDataType.Boolean:
        return NewDataType.Boolean;
      case GSPElementDataType.Date:
        return NewDataType.Date;
      case GSPElementDataType.DateTime:
        return NewDataType.DateTime;
      case GSPElementDataType.Decimal:
        return NewDataType.Decimal;
      case GSPElementDataType.Text:
        return NewDataType.String;
      default:
        return NewDataType.String;
    }
  }

}